import { useQuery } from '@tanstack/react-query';

import {
  DEFAULT_QUERY_GC_TIME_MS,
  DEFAULT_QUERY_STALE_TIME_MS,
} from '../utils/queryCache.constants';
import { LEAD_QUERY_KEYS } from '../utils/leadApi.constants';
import { getRegions } from '../services';
import { mapRegions } from '../mappers';

export function useGetRegions() {
  return useQuery({
    queryKey: LEAD_QUERY_KEYS.regions,
    queryFn: async () => {
      const dto = await getRegions();
      return mapRegions(dto);
    },
    staleTime: DEFAULT_QUERY_STALE_TIME_MS,
    gcTime: DEFAULT_QUERY_GC_TIME_MS,
  });
}
